<template>
  <!-- Left column -->
  <div v-if="isDataLoaded">
    <div class="full-width">
      <p class="card-title">
        {{ getString("module.dashboard.stats.orders") }}
      </p>
      <div class="card-block">
        <line-chart
          v-show="dataReady"
          :chartData="data"
          :options="options"
          :height="220"
          :ref="component"
        />
        <div class="legends">
          <div class="legends__col" v-for="(legends, index) in this.legendChunked()" :key="index">
            <div class="row" v-for="(legend) in legends" :key="legend.key">
              <!-- Legends -->
              <div
                class="row legend q-ml-md q-mt-md q-mb-sm"
                :class="{
                  'text-hidden': data.datasets[legend.key].hidden
                }"
                @click="toggleData(legend.key)"
              >
                <div :class="legend.color"></div>
                <span>{{ legend.label }}</span>
              </div>
              <div class="col q-mr-md q-mt-sm" style="display: flex; justify-content: right">
                <div class="legend-text">
                  {{ getString("module.dashboard.stats.total") }}:
                  <b>{{ data.totalAmounts[legend.key] }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'orders',
      data: {
        labels: [],
        totalAmounts: [],
        datasets: [
          this.initDataset(this.getColor('blue')),
          this.initDataset(this.getColor('purple')),
          this.initDataset(this.getColor('red')),
          this.initDataset(this.getColor('yellow')),
          this.initDataset(this.getColor('orange')),
        ],
        legends: [
          {
            color: 'blue',
            label: this.getString('module.dashboard.stats.orders'),
            key: 0,
          },
          {
            color: 'purple',
            label: 'Weborder (success)',
            key: 1,
          },
          {
            color: 'red',
            label: 'Weborder (failed)',
            key: 2,
          },
          {
            color: 'yellow',
            label: 'Default Cart Weborder',
            key: 3,
          },
          {
            color: 'orange',
            label: 'Dico Weborder',
            key: 4,
          },
        ],
      },
      options: {
        scales: this.scaleOptions,
        elements: {
          point: {
            radius: 2,
          },
        },
        legend: {
          display: false,
        },
      },
    };
  },
  methods: {
    handleData() {
      const orders = this.statisticData;
      const webOrders = this.$store.getters.statisticByComponent(this.type, 'webOrders');
      const defaultCartUsages = this.$store.getters.statisticByComponent(
        this.type,
        'defaultCartUsages',
      );
      const dicoUsages = this.$store.getters.statisticByComponent(this.type, 'dicoUsages');
      this.data.datasets[0].data = orders.period.map(x => x.total * 1);
      this.data.datasets[1].data = webOrders.period.map(x => x.succeeded * 1);
      this.data.datasets[2].data = webOrders.period.map(x => x.failed * 1);
      this.data.datasets[3].data = defaultCartUsages.period.map(x => x.processed * 1);
      this.data.datasets[4].data = dicoUsages.period.map(x => x.processed * 1);
      this.data.totalAmounts[0] = orders.total.total || 0;
      this.data.totalAmounts[1] = webOrders.total.succeeded || 0;
      this.data.totalAmounts[2] = webOrders.total.failed || 0;
      this.data.totalAmounts[3] = defaultCartUsages.total.processed || 0;
      this.data.totalAmounts[4] = dicoUsages.total.processed || 0;
      this.data.labels = orders.period.map(x => this.formatDate(x.date, this.labelDateFormat));
      this.dataReady = true;
    },
    legendChunked(byRow = 3) {
      return Array.from({ length: Math.ceil(this.data.legends.length / byRow) }, (v, i) => this.data.legends.slice(i * byRow, i * byRow + byRow));
    },
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
